import React from 'react'

import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import { CircularProgress } from 'material-ui/Progress'
import ParticleBackground from './ParticleBackground'

import styles from '../styles/components/LoadingSplash'

const LoadingSplash = props => {
  const { classes } = props

  return (
    <ParticleBackground>
      <Typography variant="headline" className={classes.title}>
        Loading
      </Typography>
      <CircularProgress size={60} className={classes.spinner} />
    </ParticleBackground>
  )
}

export default withStyles(styles)(LoadingSplash)



// WEBPACK FOOTER //
// ./src/components/LoadingSplash.jsx